import { render, staticRenderFns } from "./ProgramInfo.vue?vue&type=template&id=547c84fb&"
import script from "./ProgramInfo.vue?vue&type=script&lang=js&"
export * from "./ProgramInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProgramInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/ProgramInfo.vue
// module id = null
// module chunks = 